import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfileBasicSectionTranslation = SectionTranslationModel<{
  birthDate: string;
  left: {
    absenceStatus: string;
    expat: {
      false: string;
      label: string;
      true: string;
    };
    functionalManager: string;
    hierarchicalManager: string;
    hrbp: string;
    mtStatus: {
      false: string;
      label: string;
      true: string;
    };
  };
  right: {
    departureRisk: string;
    domesticMobility: string;
    education: string;
    englishLevel: string;
    internationalMobility: string;
  };
}>;

export const employeeProfileBasicSectionTranslation: EmployeeProfileBasicSectionTranslation = {
  content: {
    birthDate: '{{years}} lat, {{months}} miesięcy',
    left: {
      absenceStatus: 'Status absencji',
      expat: {
        false: 'Nieaktywny',
        label: 'Status expat',
        true: 'Aktywny',
      },
      functionalManager: 'Przełożony funkcyjny',
      hierarchicalManager: 'Przełożony hierarchiczny',
      hrbp: 'HRBP',
      mtStatus: {
        false: 'Nie',
        label: 'Status MT',
        true: 'Tak | {{year}}',
      },
    },
    right: {
      departureRisk: 'Ryzyko odejścia',
      domesticMobility: 'Mobilność krajowa',
      education: 'Wykształcenie',
      englishLevel: 'Język angielski',
      internationalMobility: 'Mobilność międzynarodowa',
    },
  },
  headerTitle: 'Dane podstawowe',
  headerTitleShorter: 'Dane podstawowe',
};
